<template>
  <v-container fill-height justify-content-start :class="{'pa-2': $vuetify.breakpoint.xsOnly}">
    <v-layout column>
      <v-form class="main-form" ref="form" v-model="valid">
        <v-layout row wrap class="flex-none">
          <v-flex xs12 sm6 class="px-1">
            <v-autocomplete
              autofocus
              :label="$t('fields.facility')"
              :items="facilities.list"
              item-value="id"
              class="required"
              v-model="facilityId"
              outline
              validate-on-blur
              item-text="name"
              :rules="required"
            />
          </v-flex>
          <v-flex xs12 sm6 class="px-1">
            <date-input :defaultValue="main.edited.checkout" :noPreviousDates="true" class="required" @change="(date) => checkout = date" icon="calendar_today" :label="$t('fields.checkout')"/>
          </v-flex>
          <v-flex xs12 class="px-1 headline font-weight-light">
            {{$t('fields.guests')}}
          </v-flex>
          <v-flex flex xs12 text-xs-left class="px-1">
            <guest
              v-for="(guest, i) in main.edited.guests"
              :key="itemKey(guest)"
              :index="i"
              :showButton="main.edited.guests.length > 1"
              @change="(guest) => updateGuest(i, guest)"
            />
            <v-btn outline @click="addGuest()">{{$t('actions.add_guest')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 text-xs-right class="px-1 flex-none">
        <v-btn :loading="loading" color="secondary" @click="submit()" :disabled="!validForm">
          {{$t('actions.submit')}}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { PANEL_LOCATION } from '@/config/environment'
import { mapState } from 'vuex'
import ValidationRules from '@/mixins/ValidationRules'
export default {
  name: 'main-view',
  mixins: [
    ValidationRules
  ],
  data () {
    return {
      loading: false,
      valid: false,
      guestKeys: new WeakMap(),
      currentGuestKey: 0
    }
  },
  components: {
    DateInput: () => import('@/components/DateInput.vue'),
    Guest: () => import('@/components/Guest.vue')
  },
  created () {
    this.$store.commit('state/setToken', this.$route.params.token)
    this.$store.dispatch('facilities/list').catch(() => {})
  },
  computed: {
    ...mapState(['facilities', 'main']),
    validForm () {
      return true
    },
    facilityId: {
      get () {
        return this.main.edited ? this.main.edited.facilityId : null
      },
      set (value) {
        this.$store.commit('main/setField', { field: 'facilityId', value })
      }
    },
    checkout: {
      get () {
        return this.main.edited ? this.main.edited.checkout : null
      },
      set (value) {
        this.$store.commit('main/setField', { field: 'checkout', value: window.moment(value).format('YYYY-MM-DDTHH:mm:ss.SSSZZ') })
      }
    }
  },
  methods: {
    itemKey (item) {
      if (!this.guestKeys.has(item)) {
        this.guestKeys.set(item, ++this.currentGuestKey)
      }
      return this.guestKeys.get(item)
    },
    updateGuest (index, guest) {
      this.$store.commit('main/editGuest', { index, guest })
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store.dispatch('main/completeForm').then(() => {
          this.$store.commit('state/setMessage', { text: this.$t('message.complete_main'), color: 'success', timeout: 0 })
          if (window.opener) {
            window.opener.postMessage('refreshData', PANEL_LOCATION)
            window.close()
          }
        }).catch(() => {
          this.loading = false
        })
      }
    },
    addGuest () {
      this.$store.commit('main/addGuest', { name: null, lastName: null, identifier: null })
    }
  }
}
</script>

<style lang="scss">
.v-text-field.currency .v-text-field__slot > input {
  text-align: right;
  margin-right: 5px;
  font-size: 30px;
  max-height: 40px;
}
.alert__no-border {
  border-top: none !important;
}
</style>
